import { DocumentPickerContainer } from '@/features/documents/DocumentPicker/DocumentPickerContainer'
import {
  DocumentRequestItem,
  DocumentRequests,
} from '@/features/documents/components/DocumentRequests'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import {
  type DocumentRequestsViewModel,
  type RequestedDocumentViewModel,
} from '@/features/documents/DocumentRequestsViewModel'
import { RemoveDocumentRequestDialogContainer } from '@/features/documents/RemoveDocumentRequestDialog/RemoveDocumentRequestDialogContainer'

export interface DocumentRequestsContainerProps {
  vm: DocumentRequestsViewModel
  isDisabled?: boolean
  readOnly?: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
}

export const DocumentRequestsContainer = observer(
  function DocumentRequestsContainer({
    vm,
    onFocus,
    isDisabled,
    focus$,
    readOnly = false,
  }: DocumentRequestsContainerProps) {
    return (
      <DocumentRequests
        isDisabled={isDisabled}
        focus$={focus$}
        onReceiveFiles={vm.uploadSupplementalFiles}
      >
        {vm.documentRequests.map((req) => (
          <DocumentRequestItemContainer
            onFocus={onFocus}
            key={req.id}
            vm={req}
            isDisabled={isDisabled}
            readOnly={readOnly}
            testId={`document-request-item-${req.id}`}
          />
        ))}
      </DocumentRequests>
    )
  },
)

interface DocumentRequestItemContainerProps {
  vm: RequestedDocumentViewModel
  isDisabled?: boolean
  onFocus?: () => unknown
  readOnly: boolean
  testId?: string
}

const DocumentRequestItemContainer = observer(
  function DocumentRequestItemContainer({
    vm,
    onFocus,
    isDisabled,
    testId,
    readOnly = false,
  }: DocumentRequestItemContainerProps) {
    const document = vm.document

    return (
      <DocumentRequestItem
        title={vm.title}
        documentTitle={document ? document.title : null}
        uploadPercent={vm.uploadPercent}
        // Only allow dropping files when there are no existing docs.
        canReceiveFiles={!vm.documentId}
        isDisabled={isDisabled}
        readOnly={readOnly}
        onFocus={onFocus}
        onReceiveFile={vm.newDocument}
        onRemove={vm.remove}
        onDownload={vm.download}
        onLink={vm.documentPickerVm.show}
        documentPicker={
          <DocumentPickerContainer
            testId="link-docs"
            vm={vm.documentPickerVm}
          />
        }
        confirmRemoval={
          <RemoveDocumentRequestDialogContainer vm={vm.removeDialogVm} />
        }
        testId={testId}
      />
    )
  },
)
